/**
 * Celular dos avisos no WhatsApp. O backend grava só dígitos e com o 55
 * (`5521999998888`); a tela mostra e edita sem o 55, com a máscara brasileira.
 */

const onlyDigits = (value: string) => value.replace(/\D/g, "");

/** `(21) 99999-8888` enquanto digita; fixo com 8 dígitos vira `(21) 3333-4444`. */
export function formatPhoneInput(value: string): string {
  const d = onlyDigits(value).slice(0, 11);
  if (d.length <= 2) return d.length ? `(${d}` : "";
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}

/** Do que veio do backend (`5521999998888`) para o campo da tela. */
export function phoneFromApi(phone: string | null | undefined): string {
  if (!phone) return "";
  const d = onlyDigits(phone);
  return formatPhoneInput(d.startsWith("55") && d.length >= 12 ? d.slice(2) : d);
}

/** Do campo para o backend: `null` quando vazio. */
export function phoneToApi(value: string): string | null {
  const d = onlyDigits(value);
  return d ? `55${d}` : null;
}

/** Vazio vale; preenchido precisa de DDD + 8 ou 9 dígitos. */
export function isPhoneValid(value: string): boolean {
  const d = onlyDigits(value);
  return d.length === 0 || d.length === 10 || d.length === 11;
}
